<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Profile</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <div class="columns is-vcentered is-centered">
          <!--If just displaying image-->
          <div v-if="!boolEditImage" class="column is-6">
            <b-image rounded :src="(fetchMyProfile.profile_picture) ? fetchMyProfile.profile_picture : require('@/assets/images/no-avatar.webp')"></b-image>
          </div>
          <!--If user clicks to edit image (Updating profile pic)-->
          <div v-else class="column is-6 has-text-centered">
            <b-field>
              <b-upload accept="image/*" v-model="prof.profile_picture" class="file-label" rounded>
                <span class="file-cta">
                  <b-icon icon="upload"></b-icon>
                  <span class="file-label">Click to upload</span>
                </span>
              </b-upload>
            </b-field>
            <b-image rounded v-if="profilePicLiveDisplay" :src="profilePicLiveDisplay"></b-image>
          </div>
          <div class="buttons">
            <b-button @click="boolEditImage = !boolEditImage" outlined type="is-info" size="is-small" icon-left="pencil"></b-button>
            <b-button v-if="fetchMyProfile.profile_picture" @click="deleteProfilePic()" outlined type="is-danger" size="is-small" icon-left="close-thick"></b-button>
          </div>
        </div>

    
        <b-field label="Introduction">
          <b-input
            ref="intro"
            v-model="prof.introduction"
            type="textarea"
            placeholder="Add a short introduction about yourself"
          ></b-input>
        </b-field>

        <b-button @click="proceed()" type="is-success" class="btn-center">Update Profile</b-button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-profile",
  data() {
    return {
      isLoading : false,
      boolEditImage : false,
      prof : {
        introduction : '',
        profile_picture : null,
        remove_profile_picture : false
      }
    };
  },
  props: {
    profile: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchMyProfile"]),
    profilePicLiveDisplay(){
      if(this.prof.profile_picture){
        return URL.createObjectURL(this.prof.profile_picture)
      }else{
        return null
      }
    }
  },
  methods: {
    ...mapActions(["updateProfile"]),
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    deleteProfilePic(){
      this.$buefy.dialog.confirm({
        title : 'Remove this Profile Picture?',
        message : `Are you sure want to remove this picture from your profile ?`,
        type : 'is-warning',
        hasIcon : true,
        onConfirm : () => {
          this.prof.remove_profile_picture = true
          this.proceed()
        }
      })
    },
    proceed() {
      this.isLoading = true;
      //For updating profile
      this.updateProfile({
        profile: this.prof,
        token: this.getTeacherToken,
      })
      .then(() => {
        this.isLoading = false;
        this.$emit("over");
        this.$buefy.toast.open({
          message: "Profile updated !",
          type: "is-success",
        });
      })
      .catch((err) => {
        this.isLoading = false;
        this.$emit("over");
        this.$buefy.toast.open({
          message: err.response.data,
          type: "is-danger",
        });
      })
    }
  },
  created(){
    this.prof.introduction = this.fetchMyProfile.introduction ? this.fetchMyProfile.introduction : ''
  },
};
</script>
<style scoped>
.image img.is-rounded{
  border-radius: 1px solid #ccc;
}
</style>